import { createSelector } from 'reselect'

export const getHasAgents = createSelector(
  (state) => state && state.user && state.user.profile && state.user.profile.info &&
    Array.isArray(state.user.profile.info.activeAddons) ? state.user.profile.info.activeAddons : [],
  (activeAddons) => {
    return !!activeAddons.find(addon => addon.action && addon.action.label === 'agents')
  }
)
